import React from 'react';
import AnalyticsContext from './AnalyticsContext';
import { AnalyticsEvent } from '../interfaces/analytics-event.interface';

type Props = {
  onClickEvent?: (event: AnalyticsEvent) => void;
};

const AnalyticsProvider: React.FC<Props> = ({ onClickEvent, children }) => {
  return (
    <AnalyticsContext.Provider
      value={{
        onClickEvent: onClickEvent,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;
